import { Action } from "redux";

import { LockType } from "../sagas/WebAuth";

export type AuthLoginRequest = "AUTH_LOGIN_REQUEST";
export const AUTH_LOGIN_REQUEST: AuthLoginRequest = "AUTH_LOGIN_REQUEST";

export type AuthLoginSuccess = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_SUCCESS: AuthLoginSuccess = "AUTH_LOGIN_SUCCESS";

export type AuthLoginFailure = "AUTH_LOGIN_FAILURE";
export const AUTH_LOGIN_FAILURE: AuthLoginFailure = "AUTH_LOGIN_FAILURE";

export interface CodeChallenge {
    codeChallenge: string;
    codeVerifier: string;
    codeChallengeMethod: string;
}

export interface AuthLoginRequestAction extends Action {
    payload: {
        awsId?: string;
        codeChallenge?: CodeChallenge;
        lockType: LockType;
        moveTo: string;
        state: string;
    };
    type: AuthLoginRequest;
}

export interface SignUpProps {
    moveTo?: string;
    codeChallenge?: CodeChallenge;
    awsId?: string;
}

const defaultSignUpProps: LoginProps = {
    moveTo: "/"
};

export function signUp(signUpProps: SignUpProps = {}): AuthLoginRequestAction {
    const props = { ...defaultSignUpProps, ...signUpProps };

    const state = crypto.randomUUID();

    return {
        payload: {
            awsId: props.awsId,
            codeChallenge: props.codeChallenge,
            lockType: LockType.SignUp,
            moveTo: props.moveTo,
            state
        },
        type: AUTH_LOGIN_REQUEST
    };
}

export type LoginProps = SignUpProps;

export function login(loginProps: LoginProps = {}): AuthLoginRequestAction {
    const props = { ...defaultSignUpProps, ...loginProps };

    const state = crypto.randomUUID();

    return {
        payload: {
            awsId: props.awsId,
            codeChallenge: props.codeChallenge,
            lockType: LockType.Login,
            moveTo: props.moveTo || "/",
            state,
        },
        type: AUTH_LOGIN_REQUEST
    };
}

export interface AuthLoginSuccessAction extends Action {
    type: AuthLoginSuccess;
}
export function loginSuccess(): AuthLoginSuccessAction {
    return {
        type: AUTH_LOGIN_SUCCESS
    };
}

export interface AuthLoginFailureAction extends Action {
    payload: {
        error: Error;
    };
    type: AuthLoginFailure;
}

export function loginFailure(error: Error): AuthLoginFailureAction {
    return {
        payload: {
            error
        },
        type: AUTH_LOGIN_FAILURE,
    };
}
